import React from "react";
import MasterTable from "../BaseMaster/MasterTable";

function GradeTable() {
  return (
    <>
      <MasterTable endpoint="/grades" name="Grades" modalName="Grade" />
    </>
  );
}

export default GradeTable;
